// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swiper-grid[data-v-fa368996]{display:flex;flex-direction:row;min-height:208px;width:100%;overflow:hidden;padding:16px}.swiper-grid .swiper-slide[data-v-fa368996]{flex:0 0 100%;min-width:0;width:100%}.v2 .swiper-slide[data-v-fa368996]{background-color:hsla(0,0%,100%,.0392156863);border-radius:8px;padding:16px}", ""]);
// Exports
module.exports = exports;
